import {
  trigger,
  state,
  style,
  transition,
  animate,
  query,
  stagger,
  sequence,
  group,
  AnimationTriggerMetadata
} from '@angular/animations';

export function FadeIn(timingIn: number, height: boolean = false): AnimationTriggerMetadata  {
  return trigger('fadeIn', [
    transition(':enter', [
      style(height ? { opacity: 0 , height: 0, } : { opacity: 0, }),
      animate(timingIn, style(height ? { opacity: 1, height: 'fit-content' } : { opacity: 1, })),
    ]),
  ]);
}

export const DropDownAnimation = trigger('dropDownMenu', [

  state('collapsed', style({
    height: '0px',
    overflow: 'hidden'    
  })),
  
  state('expanded', style({
    height: '*'
  })),
  
  transition('collapsed => expanded', [
    query("[role=\"group\"] > *", [ style({ opacity: 0, transform: "translateY(-60px)" }) ], { optional: true }),
    group([
      animate("190ms", style({ height: "*" })),
      query("[role=\"group\"] > *", [
        stagger(8, [          
          animate("200ms ease", style({ opacity: 1, transform: "none" }))          
        ])
      ], { optional: true })
    ]),
  ]),

  transition('expanded => collapsed', [
    style({ height: "*" }),
    query("[role=\"group\"] > *", [style({ opacity: 1, transform: "none" })], { optional: true }),
    sequence([
      query("[role=\"group\"] > *", [
        stagger(-8, [
          animate("100ms ease", style({ opacity: 0, transform: "translateY(-30px)" }))
        ])
      ], { optional: true }),
      animate("190ms", style({ height: 0 }))
    ])
  ])
]);
